import { Task } from '@lit-labs/task';
import { request } from '../request.js';
import { TaskController } from './task.js';

/**
 * @typedef {import('lit').LitElement} LitElement
 */

export class ConnectAccountController extends TaskController {
  /**
   * @param {LitElement} host
   */
  constructor(host) {
    super();

    this.task = new Task(
      host,
      ([account]) => {
        return request('GET', `/connect-accounts/${account}`);
      },
      () => [host.getAttribute('account')]
    );
  }
}
